export const metadata = {
  title: "Venue Spotlight: Prince Moulay Abdullah Hall 🔍",
  date: "2025-05-01",
  excerpt: "A deeper look at the venue hosting the AFCON World Cup Qualifiers",
  slug: "venue-spotlight-prince-moulay-abdullah-hall",
content: `
Taking a closer look at the host venue in Rabat

The inaugural AFCON Women's World Cup qualifiers has been quite the spectacle, with Morocco set to face Tanzania in the upcoming final.

While the competition has certainly been one of high-quality play, we are here to spotlight the venue, which is the Prince Moulay Abdullah Hall (also known as Salle Omnisport Moulay Abdellah).

With a capacity for up to 10000 spectators the venue is home to Futsal, Volleyball, Basketball as well as many other indoor sports. 

Named after Prince Moulay Abdallah of Morocco the arena was officially opened in 2000, however you wouldn’t be able to tell given how high spec it looks!
`
};
  